import * as React from 'react'
import {connect} from 'react-redux'

import {changeSorting, changeSortingDimension, changeSortingDirection} from '../../../actions'
import QuerySync, {Param} from '../../../containers/QuerySync'
import {getSorting, getSortingDescending, getSortingDimension} from '../../../selectors'

import Sorter from './Sorter'
import type {ActionProps, OwnProps, Props} from './Sorter.types'

const mapStateToProps = getSorting
const actionCreators: ActionProps = {
  onChange: changeSorting,
}

function SorterContainer(props: Props) {
  return (
    <React.Fragment>
      <QuerySync>
        <Param
          name="sort-by"
          action={changeSortingDimension}
          selector={getSortingDimension}
          defaultValue={props.dimensions[0]}
        />
        <Param
          name="sort-descending"
          action={changeSortingDirection}
          selector={getSortingDescending}
          defaultValue={false}
          stringToValue={Boolean}
        />
      </QuerySync>
      <Sorter {...props} />
    </React.Fragment>
  )
}

export default connect(
  mapStateToProps,
  actionCreators,
)(SorterContainer) as React.ComponentType<OwnProps>
